import { ref } from '@vue/composition-api'
import { ReportService } from '@/app/reports/share/report.service'

export default function Logic() {

  const request = ref({
    schedule_at: "",
   
    emails:"",
    

  })

  return {
    request
  }

  
  
}
